import { TwcProduct } from '../../../twc-products';
import { TWC_SURFACE_ANALYSIS_VECTOR_STYLE } from './surface-analysis.vector-style';

export const SURFACE_ANALYSIS_PRODUCT_DATA: TwcProduct = {
  id: 'surface-analysis',
  defaultProductId: '1264',
  productName: 'Weather-Surface-Analysis-TWC',
  label: 'Surface Analysis',
  weatherType: 'SURFACE_ANALYSIS',
  description: 'TWC product (vector) - Global Surface Analysis',
  series: 'Observation',
  timeSlicePeriodInMinutes: 180,
  lodMax: 5,
  protocol: 'VectorTile',
  forecastTimeSlicePeriod: 0,
  flightLevelProductIds: {},
  zOrder: 85,
  layerSpecs: {
    vectorTile: {
      vectorStyle: TWC_SURFACE_ANALYSIS_VECTOR_STYLE
    }
  }
};
